import React from 'react'
import PropTypes from 'prop-types'
import { DisplaySocialMedia } from 'components/DueDiligence/Questions'

import styles from './styles'

function BuildSocialMediaInfo(props) {
  const { socialNetworks } = props
  const questionData = {
    items: socialNetworks,
  }

  const classes = styles()

  return (
    <div className={classes.root}>
      <DisplaySocialMedia questionData={questionData} />
    </div>
  )
}

BuildSocialMediaInfo.propTypes = {
  socialNetworks: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string,
      type: PropTypes.string,
    }),
  ).isRequired,
}

export default BuildSocialMediaInfo
